module.exports = __webpack_public_path__ + "static/media/logo-face.f6789ea3.svg";